import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ActivityCard } from './ActivityCard';

const isHeightOverflown = (element) => {
    return element.scrollHeight > element.clientHeight;
};

export class ActivityCardContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            descriptionStyle: this.props.card.externalLink ? 'cardDescriptionShorter' : 'cardDescription',
            moreButtonStyle: 'visibilityButton',
            expanded: false,
            buttonText: this.props.activityCardText.readMore,
        };
        this.descriptionDivRef = React.createRef();
    }

    componentDidMount() {
        if (!isHeightOverflown(this.descriptionDivRef.current)) {
            this.setState({
                moreButtonStyle: 'visibilityButton hidden',
            });
        }        
    }

    handleVisibilityClick = () => {
        if (this.state.expanded) {
            this.setState({
                descriptionStyle: this.props.card.externalLink ? 'cardDescriptionShorter shrinkMore' : 'cardDescription shrink',
                expanded: false,
                buttonText: this.props.activityCardText.readMore,
            });
        } else {
            this.setState({
                descriptionStyle: this.props.card.externalLink ? 'cardDescriptionShorter grow' : 'cardDescription grow',
                expanded: true,
                buttonText: this.props.activityCardText.readLess,
            });
        }
    }

    render() {
        return (
            <ActivityCard
                ref={this.descriptionDivRef}
                cardName={this.props.card.cardName}
                cardDescription={this.props.card.cardDescription}
                cardTags={this.props.card.cardTags}
                externalLink={this.props.card.externalLink}
                grades={this.props.card.grades}
                targetSkills={this.props.card.targetSkills}
                descriptionStyle={this.state.descriptionStyle}
                buttonText={this.state.buttonText}
                moreButtonStyle={this.state.moreButtonStyle}
                handleVisibilityClick={this.handleVisibilityClick}
                activityCardText={this.props.activityCardText}
            />
        );
    }
}

ActivityCardContainer.defaultProps = {
    card: {
        cardName: 'Missing card name',
        cardDescription: 'Missing card description',
        cardTags: 'Missing card tags',
        grades: 'Missing grades',
        targetSkills: 'Missing target skills',
        externalLink: '',
    },
};

ActivityCardContainer.propTypes = {
    card: PropTypes.object,
    activityCardText: PropTypes.object.isRequired,
};

export default ActivityCardContainer;




// WEBPACK FOOTER //
// ./src/components/ActivityCardContainer.jsx